import { For, Show } from "solid-js";
import { cx } from "../../styled-system/css";
import { styles } from "../styles";
import type { FacetOption } from "../types";

type FacetProps = {
  label: string;
  name: string;
  options: FacetOption[];
  selected: ReadonlySet<string>;
  onToggle: (value: string) => void;
};

function Facet(props: FacetProps) {
  return (
    <fieldset class={styles.filterFacetFieldset}>
      <legend class={styles.label}>{props.label}</legend>
      <div class={styles.checklist}>
        <For each={props.options}>
          {(option) => (
            <label class={styles.check}>
              <input
                type="checkbox"
                name={props.name}
                value={option.value}
                checked={props.selected.has(option.value)}
                onChange={() => props.onToggle(option.value)}
              />
              <span>{option.label ?? (option.value || "（未設定）")}</span>
              <span class={styles.facetCount}>({option.count})</span>
            </label>
          )}
        </For>
      </div>
    </fieldset>
  );
}

type Props = {
  open: boolean;
  filteredCount: number;
  totalCount: number;
  showCategories?: boolean;
  brands: ReadonlySet<string>;
  terms: ReadonlySet<string>;
  categories: ReadonlySet<string>;
  facets: {
    brands: FacetOption[];
    terms: FacetOption[];
    categories: FacetOption[];
  };
  onToggleBrand: (value: string) => void;
  onToggleTerm: (value: string) => void;
  onToggleCategory: (value: string) => void;
  onReset: () => void;
  onToggleOpen: () => void;
};

export function FilterPanel(props: Props) {
  return (
    <div class={styles.popoverRoot}>
      <button class={styles.headerButton} type="button" title="データ検索" aria-label="データ検索" aria-expanded={props.open} aria-controls="data-search-panel" onClick={props.onToggleOpen}>🔍</button>
      <Show when={props.open}>
        <form id="data-search-panel" class={cx(styles.popover, styles.dataSearchPopover)} onSubmit={(event) => event.preventDefault()}>
          <header class={styles.popoverHeader}>
            <div class={styles.popoverTitleRow}>
              <strong class={styles.popoverTitle}>データ検索</strong>
              <span class={styles.popoverCount}>{props.filteredCount.toLocaleString()}/{props.totalCount.toLocaleString()}</span>
            </div>
            <button class={styles.popoverCloseButton} type="button" aria-label="データ検索を閉じる" onClick={props.onToggleOpen}>✕</button>
          </header>
          <div class={styles.filterGrid}>
            <Facet label="パーツ種別" name="term" options={props.facets.terms} selected={props.terms} onToggle={props.onToggleTerm} />
            <Show when={props.showCategories !== false}>
              <Facet label="カテゴリ" name="category" options={props.facets.categories} selected={props.categories} onToggle={props.onToggleCategory} />
            </Show>
            <Facet label="ブランド" name="brand" options={props.facets.brands} selected={props.brands} onToggle={props.onToggleBrand} />
          </div>
          <div class={styles.inline} style={{ "margin-top": "1rem" }}>
            <button class={styles.button} type="button" onClick={props.onReset}>通常検索をリセット</button>
          </div>
        </form>
      </Show>
    </div>
  );
}
